export enum ClientTrackingPage {
    PinCodeAuthorisation = 'pin_code_authorisation',
    Section3Review = 'section3_review',
    Section3ThankYou = 'section3_thankyou',
    Section2DocumentReview = 'section2_document_review',
    Section2EmployeeInformation = 'section2_employee_information',
    Section2ThankYou = 'section2_thankyou'
}



// WEBPACK FOOTER //
// ./src/models/client-tracking-page.ts